import { familyPlanSteps } from '../../../mocks/preparedness';

export default function FamilyPlan() {
  return (
    <div id="family-plan" className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Create Your Family Emergency Plan
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A well-prepared family knows what to do and where to go during an emergency. 
            Follow these steps to create your plan today.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
            {familyPlanSteps.map((step, index) => (
              <div key={step.step} className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="flex items-start gap-6 p-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg">
                      {step.step}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                        <i className={`${step.icon} text-xl text-orange-600`}></i>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900">{step.title}</h3>
                    </div>
                    <p className="text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
                {index < familyPlanSteps.length - 1 && (
                  <div className="flex justify-center">
                    <div className="w-0.5 h-6 bg-gradient-to-b from-orange-300 to-transparent"></div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Download Template */}
        <div className="mt-12 text-center">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl mx-auto">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-orange-100 to-red-100 rounded-full mb-4">
              <i className="ri-file-download-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Download Family Plan Template
            </h3>
            <p className="text-gray-600 mb-6">
              Get our free printable template to document your family's emergency plan, 
              contact information, and meeting locations.
            </p>
            <a
              href="https://www.ready.gov/sites/default/files/2020-03/family-emergency-plan.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-orange-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-download-2-line text-xl"></i>
              Download Template (PDF)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
